const parseAsNumber = (input) => {
    if (typeof input === 'number' && !Number.isNaN(input)) {
        return input;
    }
    if (typeof input !== 'string') {
        return 0;
    }
    const parsed = parseFloat(input);
    if (Number.isNaN(parsed)) {
        return 0;
    }
    return parsed;
};
export default parseAsNumber;
